import i18next from 'i18next'
import SpreadsheetFormatter from './formatter'
import CustomEditor from './editor'
import * as shortId from 'shortid'
import { updateSpreadsheet } from '../../../backend/spreadsheet/updateData'
import { createRow } from '../../../backend/spreadsheet/createRow'
import { deleteRow } from '../../../backend/spreadsheet/deleteRow'
import { updateRow } from '../../../backend/spreadsheet/updateRow'
import { getInitialRecordProperty } from '../../../logic/SM2+'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import React, { useMemo, useContext, useEffect, useState, useCallback } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'

function ColumnRenderer ({ column, sortDirection, priority, onSort, allRowSelected, onAllRowSelectionChange }) {
  const context = useContext(GlobalContext)

  const spreadsheetId = useMemo(() => (column.id), [column.id])
  const globalSpreadsheet = useMemo(() => (globalOnDemandVars.spreadsheets()[spreadsheetId]), [spreadsheetId])

  const [isQuestion, setIsQuestion] = useState(false)
  const [isAnswer, setIsAnswer] = useState(false)

  const updateState = useCallback(
    () => {
      setIsQuestion(
        globalSpreadsheet.selectedItems1.some((selectedName) => (selectedName === column.name))
      )
      setIsAnswer(
        globalSpreadsheet.selectedItems2.some((selectedName) => (selectedName === column.name))
      )
    },
    [column.name, globalSpreadsheet.selectedItems1, globalSpreadsheet.selectedItems2]
  )

  useEffect(updateState, [])

  useEffect(() => {
    const changedSpreadsheetInfo = globalOnDemandVars.changedSpreadsheetInfo()
    if (changedSpreadsheetInfo.id === spreadsheetId) {
      setIsQuestion(
        globalSpreadsheet.selectedItems1.some((selectedName) => (selectedName === column.name))
      )
      setIsAnswer(
        globalSpreadsheet.selectedItems2.some((selectedName) => (selectedName === column.name))
      )
    }
  }, [spreadsheetId, updateState, context.spreadsheetChangeDetect, globalSpreadsheet.selectedItems1, globalSpreadsheet.selectedItems2, column.name])

  return useMemo(() => (
    (isQuestion && isAnswer) ? (
      <div css={css`position: absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: var(--gray4);`}>
        <div css={css`z-index: 10; position: absolute; width: 100%; height: 100%; top: 0; left: 0; padding: var(--s-2);`}>
          {column.name}
        </div>
        <div css={css`position: absolute; width: 100%; height: 20%; top: 60%; left: 0; background-color: var(--gray4);`} />
        <div css={css`position: absolute; width: 100%; height: 20%; top: 80%; left: 0; background-color: var(--answerColor);`} />
      </div>
    ) : (
      <div css={css`position: absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: var(--gray4);`}>
        <div css={css`z-index: 10; position: absolute; width: 100%; height: 100%; top: 0; left: 0; padding: var(--s-2);`}>
          {column.name}
        </div>
        <div css={css`position: absolute; width: 100%; height: 20%; top: 80%; left: 0;`} style={{ backgroundColor: isAnswer ? 'var(--answerColor)' : (isQuestion ? 'var(--gray4)' : ' var(--baseColor)') }} />
      </div>
    )
  ), [column.name, isAnswer, isQuestion])
}

function ColumnRenderer2 (props) {
  return <ColumnRenderer {...props} />
}

export class Column {
  constructor (name, id) {
    this.key = name
    this.id = id
    this.name = name
    this.editable = true
    this.formatter = SpreadsheetFormatter
    this.editor = CustomEditor
    this.resizable = true
    this.headerRenderer = ColumnRenderer2
  }
}

// export class Row {
//   constructor () {
//     this.id = shortId.generate()
//   }
// }
export function getRow (config = {}) {
  return {
    timeStamp: Date.now(),
    configForRow: {
      id: config.id || shortId.generate(),
      ...getInitialRecordProperty()
    }
  }
}

const getColumnName = (column) => (column.name)
export class Spreadsheet {
  constructor (id, config) {
    // this.id = shortId.generate()
    this.id = id
    if (config) {
      this.rows = config.rows || [getRow()]
      this.columns = config.columns
      this.selectedItems1 = config.selectedItems1
      this.selectedItems2 = config.selectedItems2
      this.configForItems1 = config.configForItems1
      this.configForItems2 = config.configForItems2
      this.switchForMultipleCard = config.switchForMultipleCard
    } else {
      this.rows = [getRow()]
      this.columns = [i18next.t('front'), i18next.t('back')]
      this.selectedItems1 = [i18next.t('front')]
      this.selectedItems2 = [i18next.t('back')]
      this.configForItems1 = { front: { fontSize: 36 } }
      this.configForItems2 = { back: { fontSize: 36 } }
      this.switchForMultipleCard = true
    }
  }

  setRows (newRows) {
    this.rows = newRows
    // updateSpreadsheet(this.id, { rows: newRows })
  }
  createRow (newRow) {
    this.rows.push(newRow)
    if (!globalOnDemandVars.isPixelMode()) { createRow(this.id, newRow.configForRow.id, newRow) }
  }
  deleteRow (rowId) {
    const index = this.rows.findIndex((row) => (row.configForRow.id === rowId))
    this.rows.splice(index, 1)
    if (!globalOnDemandVars.isPixelMode()) { deleteRow(this.id, rowId) }
  }
  updateRow (rowId, update) {
    const index = this.rows.findIndex((row) => (row.configForRow.id === rowId))
    this.rows[index] = {
      ...this.rows[index],
      ...update
    }
    if (!globalOnDemandVars.isPixelMode()) { updateRow(this.id, rowId, update) }
  }
  // -----------------------------------------------------------------------------------------------------------
  setColumns (newColumns) {
    this.columns = newColumns.map(getColumnName)
    if (!globalOnDemandVars.isPixelMode()) { updateSpreadsheet(this.id, { columns: this.columns }) }
  }
  setSelectedItems1 (newVar) {
    this.selectedItems1 = newVar.map(getColumnName)
    if (!globalOnDemandVars.isPixelMode()) { updateSpreadsheet(this.id, { selectedItems1: this.selectedItems1 }) }
  }
  setSelectedItems2 (newVar) {
    this.selectedItems2 = newVar.map(getColumnName)
    if (!globalOnDemandVars.isPixelMode()) { updateSpreadsheet(this.id, { selectedItems2: this.selectedItems2 }) }
  }
  setConfig1 (newVar) {
    this.configForItems1 = newVar
    if (!globalOnDemandVars.isPixelMode()) { updateSpreadsheet(this.id, { configForItems1: newVar }) }
  }
  setConfig2 (newVar) {
    this.configForItems2 = newVar
    if (!globalOnDemandVars.isPixelMode()) { updateSpreadsheet(this.id, { configForItems2: newVar }) }
  }
  setSwitchForMultipleCard (newVar) {
    this.switchForMultipleCard = newVar
    if (!globalOnDemandVars.isPixelMode()) { updateSpreadsheet(this.id, { switchForMultipleCard: newVar }) }
  }

  setForPixelMode ({ rows, columns, selectedItems1, selectedItems2, configForItems1, configForItems2 }) {
    this.rows = rows
    this.columns = columns
    this.selectedItems1 = selectedItems1
    this.selectedItems2 = selectedItems2
    this.configForItems1 = configForItems1
    this.configForItems2 = configForItems2
  }
}
